// @module BluePoint.WebinarForm.WebinarForm
define('BluePoint.WebinarForm.WebinarForm.View'
	, [
		'bluepoint_webinarform_webinarform.tpl'
		, 'BluePoint.WebinarForm.WebinarForm.Model'
		, 'Backbone'
	]
	, function (
		bluepoint_webinarform_webinarform_tpl
		, WebinarFormModel
		, Backbone
	) {
		'use strict';

		// @class BluePoint.WebinarForm.WebinarForm.View @extends Backbone.View
		return Backbone.View.extend({

			template: bluepoint_webinarform_webinarform_tpl

			, initialize: function (options) {
				this.model = new WebinarFormModel();
				this.application = options.application;
				var self = this;
			}

			, events: {
				'submit [data-action="login"]': 'doLogin',
				'submit [data-action="register"]': 'doRegister',
				'click [data-action="tab-switch"]': 'onTabClick'
			}

			, render: function () {
				this._render();
				this.afterViewRender();
			}

			, afterViewRender: function () {
				this.$('.tab-btn').first().addClass('active');
				this.$('.webinar-tab-content').first().addClass('active');

				// --- Elements ---
				var self = this;
				var passField = this.$('#password');
				var confirmField = this.$('#confirmpassword');
				var phoneField = this.$('#phone');


				// Password checklist UI
				var checklistHtml = `
        			<ul id="password-checklist" style="list-style:none; padding-left:0; font-size:12px;">
        			    <li data-rule="length">❌ At least 8 characters long</li>
        			    <li data-rule="number">❌ Include numbers</li>
        			    <li data-rule="case">❌ Use uppercase and lowercase letters</li>
        			    <li data-rule="special">❌ Add at least one special character (e.g., ! @ # $ %)</li>
        			    <li data-rule="common">❌ Avoid common patterns (e.g., password123, example@123)</li>
        			    <li data-rule="strength">❌ Choose a strong password that is hard to guess</li>
        			</ul>
    			`;
				self.$('#pass_error_msg').html(checklistHtml);

				// List of common weak passwords/patterns
				var weakPatterns = [
					"password", "123456", "qwerty", "example@123", "letmein", "welcome",
					"admin", "test123", "user123", "abc123", "iloveyou"
				];

				// Runtime password validation
				passField.on('keyup', function () {
					var val = $(this).val();

					// Length
					updateRule("length", val.length >= 8);

					// Numbers
					updateRule("number", /[0-9]/.test(val));

					// Upper + lower case
					updateRule("case", /[a-z]/.test(val) && /[A-Z]/.test(val));

					// Special characters
					updateRule("special", /[!@#$%^&*(),.?\":{}|<>]/.test(val));

					// Common patterns check
					var isCommon = weakPatterns.some(function (pattern) {
						return val.toLowerCase().includes(pattern);
					});
					// Mark invalid if empty OR matches weak pattern
					updateRule("common", val.length > 0 && !isCommon);

					// Strength / hard to guess (at least 3 of: lower, upper, number, special)
					var checksPassed = 0;
					if (/[a-z]/.test(val)) checksPassed++;
					if (/[A-Z]/.test(val)) checksPassed++;
					if (/[0-9]/.test(val)) checksPassed++;
					if (/[!@#$%^&*(),.?\":{}|<>]/.test(val)) checksPassed++;
					updateRule("strength", checksPassed >= 3 && val.length >= 10);
				});

				function updateRule(rule, condition) {
					var el = self.$('#password-checklist [data-rule="' + rule + '"]');
					var text = el.text().replace("✅", "").replace("❌", "").trim();
					if (condition) {
						el.html("✅ " + text);
					} else {
						el.html("❌ " + text);
					}
				}

				// --- Confirm password real-time check ---
				confirmField.on('keyup', function () {
					if ($(this).val() !== passField.val()) {
						self.$('#repass_error_msg').css('color', 'red').text('*Passwords do not match.');
					} else {
						self.$('#repass_error_msg').text('');
					}
				});

				// --- Phone number real-time check ---
				var phonePattern = /^[0-9]{7,15}$/;
				phoneField.on('keyup', function () {
					var val = $(this).val();
					if (!phonePattern.test(val)) {
						self.$('#phone_error_msg').css('color', 'red').text('*Phone number is invalid.');
					} else {
						self.$('#phone_error_msg').text('');
					}
				});
			}

			// Tab switcher logic
			, onTabClick: function (e) {
				e.preventDefault();

				var tab = jQuery(e.currentTarget).data('tab');

				// remove active from all buttons + content
				this.$('.tab-btn').removeClass('active');
				this.$('.webinar-tab-content').removeClass('active');

				// activate clicked tab + matching content
				jQuery(e.currentTarget).addClass('active');
				this.$('#tab-' + tab).addClass('active');
			}

			, doLogin: function (e) {
				e.preventDefault();
				var self = this;

				var email = this.$('[name="login-email"]').val();
				var password = this.$('[name="login-password"]').val();

				if (!email || !password) {
					self.application.getLayout().showErrorInModal('Please fill all required fields.');
					return;
				}

				var data = {
					form: 'login',
					email: email,
					password: password,
					occupation: this.$('[name="login-occupation"]').val()
				};

				this.model.save(data, {
					success: function (model, resp) {
						var response = resp || model.toJSON();
						// alert(JSON.stringify(response));
						if (response && response.success) {
							if (response.message == 'WebinarFull') {
								var modal = self.application.getLayout().showErrorInModal(`
    								<div style="
    								    font-family: Arial, sans-serif; 
    								    color: #333; 
    								    line-height: 1.5;
    								    text-align: center;
										margin: auto;
    								">
    								    <p style="font-size: 14px;">Thank you for your interest in the webinar titled <strong>"IDDSI Food Prep"</strong>.</p>
    								    <p style="margin: 10px 0 20px; font-size: 14px;">
    								        Unfortunately, this session is <strong>full</strong>.
    								    </p>

    								    <a href="https://www.simplythick.com" data-touchpoint="home" style="
    								        display: inline-block;
    								        padding: 10px 20px;
    								        background-color: #0275d8;
    								        color: #fff;
    								        text-decoration: none;
    								        border-radius: 5px;
    								        font-weight: bold;
    								        transition: background-color 0.3s;
    								    " onmouseover="this.style.backgroundColor='#025aa5'" onmouseout="this.style.backgroundColor='#0275d8'">
    								        Continue Shopping on Home Page
    								    </a>
    								</div>
								`);

								// Wait a tiny moment for the modal to be in the DOM
								setTimeout(function () {
									$('.global-views-modal-content-header-title#modal-title-label').html('<h2 style="color: #d9534f; margin-bottom: 15px;">Webinar Full</h2>');
								}, 50);
							}
							else if (response.message) {
								window.location.href = response.message;
							}
						}
						else {
							var errorMsg = 'Login failed';
							if (response.message) {
								try {
									var parsed = JSON.parse(response.message);
									if (parsed.details) {
										errorMsg += ': message : ' + parsed.details;
										self.application.getLayout().showErrorInModal(parsed.details);
									} else {
										errorMsg += ': message : ' + response.message;
									}
								} catch (e) {
									errorMsg += ': ' + response.message;
								}
							}
							console.log(errorMsg);
						}
					},
					error: function (model, err) {
						var msg = 'Error occurred';
						try {
							msg += ': ' + (err.responseJSON?.message || err.responseText || err.statusText || JSON.stringify(err));
						} catch (e) {
							msg += ': unknown error';
						}
						self.application.getLayout().showErrorInModal(msg);
					}
				});
			}

			// Utility function to clear password fields and reset checklist
			, clearPasswordFieldsAndResetChecklist: function () {
				var self = this;
				this.$('[name="password"]').val('');
				this.$('[name="confirmpassword"]').val('');

				var rules = ['length', 'number', 'case', 'special', 'common', 'strength'];
				rules.forEach(function (rule) {
					var el = self.$('#password-checklist [data-rule="' + rule + '"]');
					var text = el.text().replace("✅", "").replace("❌", "").trim();
					el.html('❌ ' + text);
				});
			}

			, doRegister: function (e) {
				e.preventDefault();
				var self = this;

				var password = this.$('[name="password"]').val();
				var confirmPassword = this.$('[name="confirmpassword"]').val();
				var phone = this.$('[name="phone"]').val();
				var phonePattern = /^[0-9]{7,15}$/;

				// Clear previous errors
				// this.$('#pass_error_msg').html('');
				this.$('#repass_error_msg').html('');
				this.$('#phone_error_msg').html('');

				var valid = true;

				// Password length
				if (password.length < 8) {
					valid = false;
				}

				// Confirm password
				if (password !== confirmPassword) {
					this.$('#repass_error_msg').html('*Passwords do not match.');
					valid = false;
				}

				// Phone validation
				if (!phone.match(phonePattern)) {
					this.$('#phone_error_msg').html('*Phone number is invalid.');
					valid = false;
				}

				if (!valid) return; // stop submission

				var data = {
					form: 'register',
					firstname: this.$('[name="firstname"]').val(),
					middlename: this.$('[name="middlename"]').val(),
					lastname: this.$('[name="lastname"]').val(),
					companyname: this.$('[name="companyname"]').val(),
					email: this.$('[name="email"]').val(),
					password: password,
					confirmpassword: confirmPassword,
					phone: phone,
					state: this.$('[name="state"]').val(),
					country: this.$('[name="country"]').val(),
					extension: this.$('[name="extension"]').val(),
					occupation: this.$('[name="occupation"]').val()
				};

				this.model.save(data, {
					success: function (model, resp) {
						var response = resp || model.toJSON();
						// alert(JSON.stringify(response));
						if (response && response.success) {
							if (response.message == 'WebinarFull') {
								self.application.getLayout().showErrorInModal(`
    								<div style="
    								    font-family: Arial, sans-serif; 
    								    color: #333; 
    								    line-height: 1.5;
    								    text-align: center;
										margin: auto;
    								">
    								    <p style="font-size: 14px;">Thank you for your interest in the webinar titled <strong>"IDDSI Food Prep"</strong>.</p>
    								    <p style="margin: 10px 0 20px; font-size: 14px;">
    								        Unfortunately, this session is <strong>full</strong>.
    								    </p>

    								    <a href="https://www.simplythick.com" data-touchpoint="home" style="
    								        display: inline-block;
    								        padding: 10px 20px;
    								        background-color: #0275d8;
    								        color: #fff;
    								        text-decoration: none;
    								        border-radius: 5px;
    								        font-weight: bold;
    								        transition: background-color 0.3s;
    								    " onmouseover="this.style.backgroundColor='#025aa5'" onmouseout="this.style.backgroundColor='#0275d8'">
    								        Continue Shopping on Home Page
    								    </a>
    								</div>
								`);

								// Wait a tiny moment for the modal to be in the DOM
								setTimeout(function () {
									$('.global-views-modal-content-header-title#modal-title-label').html('<h2 style="color: #d9534f; margin-bottom: 15px;">Webinar Full</h2>');
								}, 50);
							}
							else if (response.message) {
								window.location.href = response.message;
							}
						}
						else {
							var errorMsg = 'Registration failed';
							if (response.message) {
								try {
									var parsed = JSON.parse(response.message);
									if (parsed.details) {
										errorMsg += ': message : ' + parsed.details;
										if (parsed.details.trim() == 'Password is in the list of compromised passwords.') {

											self.$('[name="password"]').val('');
											self.$('[name="confirmpassword"]').val('');

											self.clearPasswordFieldsAndResetChecklist();

											self.application.getLayout().showErrorInModal(
												'<div style="padding:15px; font-family:Arial, sans-serif;">' +
												'<p style="font-size:14px; color:#333; margin:0 0 8px 0;">' +
												'Your chosen password is in a list of compromised passwords.' +
												'</p>' +
												'<p style="font-size:14px; color:#333; margin:0 0 8px 0;">' +
												'<strong>Please choose a stronger password</strong> that is hard to guess.' +
												'</p>' +
												'<ul style="font-size:14px; color:#333; margin:0 0 8px 20px;">' +
												'<li>At least 8 characters long</li>' +
												'<li>Include numbers</li>' +
												'<li>Use uppercase and lowercase letters</li>' +
												'<li>Add at least one special character (e.g., ! @ # $ %)</li>' +
												'</ul>' +
												'<p style="font-size:13px; color:#666; margin-top:15px;">' +
												'This policy is in place to keep your account secure and the system reliable.' +
												'</p>' +
												'</div>'
											);

											// Wait a tiny moment for the modal to be in the DOM
											setTimeout(function () {
												$('.global-views-modal-content-header-title#modal-title-label').html('<h2 style="color: #d9534f; margin-bottom: 15px;">⚠️ Weak Password Detected</h2>');
											}, 50);
										}
										else {
											self.application.getLayout().showErrorInModal(parsed.details);
										}

									} else {
										errorMsg += ': message : ' + response.message;
									}
								} catch (e) {
									errorMsg += ': ' + response.message;
								}
							}
							console.log(errorMsg);
						}
					},
					error: function (model, err) {
						var msg = 'Error occurred';
						try {
							msg += ': ' + (err.responseJSON?.message || err.responseText || err.statusText || JSON.stringify(err));
						} catch (e) {
							msg += ': unknown error';
						}
						self.application.getLayout().showErrorInModal(msg);
					}
				});
			}

			, bindings: {
			}

			, childViews: {

			}

			//@method getContext @return BluePoint.WebinarForm.WebinarForm.View.Context
			, getContext: function getContext() {
				//@class BluePoint.WebinarForm.WebinarForm.View.Context
				this.message = this.message || 'Hello World!!'
				return {
					message: this.message
				};
			}
		});
	});
